import React from 'react'
// containers
import RisksRegisterContainer from 'containers/Risks/RisksRegister'

const RisksRegisterPage: React.FC = () => <RisksRegisterContainer />

export default RisksRegisterPage
